import { MazeCardPalette } from '@/apps/maze/MazeCardPalette';
import type { NodeKind } from '@/flow/types';
import type { FlowDisplayLanguage } from '@/flow/displayLanguage';

type LearningCardPaletteProps = {
  availableNodeKinds: readonly NodeKind[];
  displayLanguage: FlowDisplayLanguage;
  onTapAdd: (kind: NodeKind) => void;
};

export function LearningCardPalette({ availableNodeKinds, displayLanguage, onTapAdd }: LearningCardPaletteProps) {
  return (
    <MazeCardPalette
      allowedNodeKinds={availableNodeKinds}
      displayLanguage={displayLanguage}
      onTapAdd={onTapAdd}
    />
  );
}